import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";

export default function AllAccessPassDialog({
  open,
  onClose,
  onSubmit,
  storePrice,
  setStorePrice,
  storeType,
  setStoreType,
  periodType,
  setPeriodType,
  localizedPrice,
  setLocalizedPrice,
  transactionCurrency,
  setTransactionCurrency,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="all-access-dialog-title"
      aria-describedby="all-access-dialog-description"
    >
      <DialogTitle id="all-access-dialog-title">All Access Pass</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sx={{ m: 0, p: 1 }}>
            <TextField
              id="storeprice"
              label="Store Price"
              fullWidth
              value={storePrice}
              variant="standard"
              onChange={(e) => setStorePrice(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sx={{ m: 0, p: 1 }}>
            <TextField
              id="localizedprice"
              label="Localized Price"
              type="number"
              fullWidth
              value={localizedPrice}
              variant="standard"
              inputProps={{ step: 0.01, min: 0 }}
              onChange={(e) =>
                setLocalizedPrice(
                  e.target.value === "" ? 0 : Number(e.target.value)
                )
              }
            />
          </Grid>
          <Grid item xs={12} sx={{ m: 0, p: 1 }}>
            <TextField
              id="transactioncurrency"
              label="Transaction Currency"
              fullWidth
              value={transactionCurrency}
              variant="standard"
              onChange={(e) => setTransactionCurrency(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sx={{ m: 0, p: 1 }}>
            <FormControl fullWidth variant="standard">
              <InputLabel id="store-select-label">Store</InputLabel>
              <Select
                labelId="store-select-label"
                id="store-select"
                value={storeType}
                onChange={(e) => setStoreType(e.target.value)}
              >
                <MenuItem value="Apple">Apple</MenuItem>
                <MenuItem value="Google">Google</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sx={{ m: 0, p: 1 }}>
            <FormControl fullWidth variant="standard">
              <InputLabel id="period-select-label">Period</InputLabel>
              <Select
                labelId="period-select-label"
                id="period-select"
                value={periodType}
                onChange={(e) => setPeriodType(e.target.value)}
              >
                <MenuItem value="Monthly">Monthly</MenuItem>
                <MenuItem value="Weekly">Weekly</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSubmit} autoFocus>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
